var scrollPosition = window.pageYOffset;
document.addEventListener('scroll', function () {
  if (document.querySelector('.product__info-container') != null) {
    requestAnimationFrame(function () {
      calcPlacement();
    });
  }
});

function calcPlacement() {
  const windowHeight = window.innerHeight;
  const componentWrapper = document.querySelector('.product__info-container');
  const componentHeight = componentWrapper.clientHeight;
  const navAndBreadcrumbsHeight = 100;

  const scrollYPosition = window.scrollY;
  const isScrollingDown = scrollYPosition >= scrollPosition;

  const componentBoundingRect = componentWrapper.getBoundingClientRect(); // Component
  const containerBoundingRect = document.querySelector('.product__info-wrapper').getBoundingClientRect(); // Container

  if (componentHeight <= windowHeight - navAndBreadcrumbsHeight) {
    setPosition('sticky', navAndBreadcrumbsHeight);
  } else if (
    isScrollingDown &&
    Math.abs(componentBoundingRect.top - navAndBreadcrumbsHeight) >=
      Math.max(componentHeight - windowHeight + navAndBreadcrumbsHeight, 0)
  ) {
    setPosition('sticky', windowHeight - componentHeight);
  } else if (!isScrollingDown && componentBoundingRect.top >= navAndBreadcrumbsHeight) {
    setPosition('sticky', navAndBreadcrumbsHeight);
  } else {
    setPosition('relative', -1 * containerBoundingRect.y + componentBoundingRect.top);
  }

  scrollPosition = Math.max(scrollYPosition, 0);
}

function setPosition(t, e) {
  document.querySelector('.product__info-container').style.position = t;
  document.querySelector('.product__info-container').style.top = e + 'px';
}
